module.exports = __webpack_public_path__ + "img/banner4.f83dd53a.jpg";